



























import Vue, { PropType } from "vue";
import { Novel, Manuscript } from "@/lib/models";

export default Vue.extend<{}, Methods, Computed, Props>({
  props: {
    sharedLinkId: {
      type: String as PropType<string>,
    },
    novelId: {
      type: String as PropType<string>,
    },
    manuscriptKey: {
      type: String as PropType<string>,
    },
  },
  methods: {
    async select(manuscriptKey) {
      const { sharedLinkId, novelId } = this;
      this.$router.push({
        name: "sharedManuscript",
        params: {
          sharedLinkId,
          novelId,
          manuscriptKey,
        },
      });
    },
  },
  computed: {
    novel() {
      return this.$store.getters["sharedLinkModule/novel"];
    },
    manuscriptList() {
      return this.$store.getters["sharedLinkModule/manuscriptList"];
    },
    novelTitle() {
      const { title } = this.novel;
      return title || "(作品タイトル未設定)";
    },
  },
});

interface Props {
  sharedLinkId: string;
  novelId: string;
  manuscriptKey: string;
}

interface Computed {
  novel: Novel;
  manuscriptList: Manuscript[];
  novelTitle: string;
}

interface Methods {
  select: (manuscriptKey: string) => void;
}
